import type {
  AdoptionOverview,
  AdoptionRangeQuery,
  CustomerAdoptionDetail,
  CustomersAdoptionQuery,
  UserAdoptionDetail,
} from '@enmon/commons/lib/enmon';
import { BaseApiClient } from '../baseApiClient';

/** The overview of all customers takes the range and, optionally, the customer to narrow it to */
export type CustomersAdoptionRequest = AdoptionRangeQuery & CustomersAdoptionQuery;

export class BackendGatewayAdoptionApiClient extends BaseApiClient {
  constructor(jwt: string) {
    super('enmon-tools/adoption', undefined, jwt);
  }

  public async findCustomers(query: CustomersAdoptionRequest, signal?: AbortSignal): Promise<AdoptionOverview> {
    const response = await this.axios.get<AdoptionOverview>('/customers', { params: query, signal });

    return response.data;
  }

  public async findCustomer(
    customerId: string,
    range: AdoptionRangeQuery,
    signal?: AbortSignal,
  ): Promise<CustomerAdoptionDetail> {
    const response = await this.axios.get<CustomerAdoptionDetail>(`/customers/${customerId}`, { params: range, signal });

    return response.data;
  }

  public async findUser(
    customerId: string,
    userId: string,
    range: AdoptionRangeQuery,
    signal?: AbortSignal,
  ): Promise<UserAdoptionDetail> {
    const response = await this.axios.get<UserAdoptionDetail>(`/customers/${customerId}/users/${userId}`, {
      params: range,
      signal,
    });

    return response.data;
  }
}
